import { combineReducers } from 'redux'
import stages from './stages'
import fields from './fields'
import dateRange from './dateRange'
import id from './id'
import calendar from './calendar'
import status from './status'
import placeholderTasks from './placeholderTasks'

export default combineReducers({
	dateRange,
	fields,
	stages,
	id,
	calendar,
	status,
	placeholderTasks,
})
